import React from 'react';
import ReactDOM from 'react-dom';
import AgentForm from "../AgentForm/AgentForm";
import AgentDuplicateModal from "../CRUDAgent/AgentDuplicateModal";
import Alert from "../Alert";
import FirmDrawer from "../FirmDrawer/FirmDrawer";
import { createAgent, DUPLICATE_AGENT } from '../../requests/agents';

export default class AgentDrawer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {},
            paneIndex: 0,
            isBusy: null,
            error: null,
            shouldOpenDrawer: false,
            newFirm: false,
            duplicates: null,
            duplicateMessage: null,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleDropdownChange = this.handleDropdownChange.bind(this);
        this.saveData = this.saveData.bind(this);
        this.addNewItem = this.addNewItem.bind(this);
        this.savedNewFirm = this.savedNewFirm.bind(this);
    }

    componentDidUpdate(prevProps){
        if(prevProps.resetDrawer !== this.props.resetDrawer && this.props.resetDrawer === true)
            this.setState({data:{}});
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.openDrawerCallback) {
            this.setState({shouldOpenDrawer: true});
        }
    }

    savedNewFirm(newData) {
        // select the new item id & close drawer
        const key = this.state.addNewItemType;
        const state = {
            data: {...this.state.data, [key]: newData.ARCIMEDES_ROW_ID},
            newFirm: newData
        };
        this.setState(state);
    }

    addNewItem() {
        this.setState({addNewItemType: 'FIRM'});
        const renderedComponent = () =>
            <FirmDrawer savedNewItem={this.savedNewFirm}
                        closeDrawer={this.state.shouldOpenDrawer ? this.props.closeChildDrawer : null}
                        resetDrawer={this.props.resetChildDrawer}/>;

        if (this.state.shouldOpenDrawer)
            this.props.openDrawerCallback(renderedComponent);
    }

    handleSubmit(e) {
        e.preventDefault();
        this.saveData();
    }

    handleChange(key, value) {
        const data = {...this.state.data};
        data[key] = value;
        this.setState({data});
    }

    handleDropdownChange(data) {
        this.setState({data});
    }

    saveData(force = false) {
        if (this.state.isBusy) return;

        this.setState({
            isBusy: true,
            error: null,
        });

        // The agent screen's own add: the Kore lead first, then the agent.
        return createAgent(this.state.data, { force }).then(agent => {
            this.setState({isBusy: false, duplicates: null});
            this.props.savedNewItem(agent, this.state.newFirm);

            if (this.props.closeDrawer) {
                this.props.closeDrawer();
                setTimeout(() => this.setState({data: {}, newFirm: false}), 1000);
            }
        }).catch(err => {
            if (err && err.code === DUPLICATE_AGENT) {
                this.setState({isBusy: null, duplicates: err.data || [], duplicateMessage: err.message});
                return;
            }

            this.setState({
                isBusy: null,
                error: err && err.message ? err.message : 'Unspecified error',
            });
        });
    }

    render() {
        const data = this.state.data;
        return (
            <React.Fragment>
                <AgentForm data={data}
                           paneIndex={this.state.paneIndex}
                           handleSubmit={this.handleSubmit}
                           handleCancel={this.props.closeDrawer}
                           handleParentChange={this.handleChange}
                           handleParentDropdownChange={this.handleDropdownChange}
                           handlePaneChange={(key) => this.setState({paneIndex: key})}
                           addNewItem={this.addNewItem}
                           newFirm={this.state.newFirm}
                />
                {this.state.error && <Alert type='error'>{this.state.error}</Alert>}
                {ReactDOM.createPortal(
                    <AgentDuplicateModal
                        show={Boolean(this.state.duplicates)}
                        message={this.state.duplicateMessage}
                        agents={this.state.duplicates || []}
                        busy={Boolean(this.state.isBusy)}
                        error={this.state.duplicates ? this.state.error : null}
                        onBack={() => this.setState({duplicates: null, error: null})}
                        onAddAnyway={() => this.saveData(true)}
                    />,
                    document.body,
                )}
            </React.Fragment>
        );
    }
}

